import React, { Component, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Accordion, Button, Card, Col, Container, Row, Form, Spinner } from "react-bootstrap";
import FormRow from "../common/forms/FormRow";
import SelectInput from "../common/forms/SelectInput";
import { getYearsWithData, getSubAcountRevShareYTD } from "../../apis/revshare/ReportsApi";
import DataGrid from "../common/DataGrids/DataGrid";

class SubAccountsYtdReport extends Component {
  render() {
    return (
      <Container fluid>
        <Row>
          <Form>
            <FormRow
              columns={[
                <SelectInput
                  default={this.state.year.toString()}
                  label="Year"
                  onChange={this.changeYear}
                  options={this.state.years}
                  ref={(element) => (this.yearSelect = element)}
                />,
              ]}
            />
          </Form>
        </Row>
        <Row>
          <Col>
            <SubAccountsYtdGrid isManger={this.props.isManger} year={this.state.year} />
          </Col>
        </Row>
      </Container>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      year: new Date().getFullYear(),
      years: [],
    };

    this.changeYear = this.changeYear.bind(this);
  }

  componentDidMount() {
    getYearsWithData()
      .then((years) => this.setState({ years: years }))
      .catch((error) => {
        throw error;
      });
  }

  changeYear() {
    this.setState({ year: this.yearSelect.value });
  }
}

SubAccountsYtdReport.propTypes = {
  isManger: PropTypes.bool,
};

export default SubAccountsYtdReport;

const SubAccountsYtdGrid = ({ isManger, year }) => {
  const headers = [
    { label: "Sub Account", key: "subAccount" },
    { label: "Current Balance", key: "currentBalance" },
    { label: "Current Hours", key: "currentHours" },
    { label: "Starting Balance", key: "startBalance" },
    { label: "Starting Hours", key: "startHours" },
    { label: "Dollars Earned", key: "valueEarned" },
    { label: "Hours Earned", key: "hoursEarned" },
    { label: "Dollars Used", key: "valueUsed" },
    { label: "Hours Used", key: "hoursUsed" },
    { label: "Net Hours Change", key: "netHoursDifference" },
    { label: "Net Dollars Change", key: "netValueDifference" },
  ];

  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [subAccountSelect, setSubAccountSelect] = useState([]);

  useEffect(() => {
    setLoading(true);
    getSubAcountRevShareYTD(year, isManger)
      .then((data) => {
        setLoading(false);
        setData(data);
        setAllData(data);
      })
      .catch((error) => {
        throw error;
      });
  }, [year]);

  const filterGrid = () => {
    let filtered = allData;
    if (subAccountSelect.value !== "All") {
      filtered = filtered.filter((i) => i.subAccount === subAccountSelect.value);
    }
    setData(filtered);
  };

  return (
    <>
      <Row>
        <Col xs="12">
          <Accordion>
            <Card style={{ border: "none" }}>
              <Accordion.Toggle as={Button} variant="link" eventKey="0">
                Filter
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="0">
                <Form>
                  <FormRow
                    columns={[
                      <SelectInput
                        default="All"
                        label="Sub Account"
                        onChange={filterGrid}
                        options={data
                          .map((i) => i.subAccount)
                          .filter((v, i, a) => a.indexOf(v) === i)
                          .sort()}
                        ref={(element) => setSubAccountSelect(element)}
                      />,
                    ]}
                  />
                </Form>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Col>
      </Row>
      <Row>
        {loading ? <Spinner animation="border" /> : null}
        <DataGrid data={data} exportName="subAccountsYtdReport" headers={headers} />
      </Row>
    </>
  );
};

SubAccountsYtdGrid.propTypes = {
  isManger: PropTypes.bool,
  year: PropTypes.number.isRequired,
};
